var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject, transient } from "aurelia-framework";
import { I18N } from "aurelia-i18n";
import { ChildComponent } from "../../../../pages/modules/child-component";
import { NotificationClientService } from "../../../../../services/basics/notification-client.service";
import { BrandRenderLayout } from "./brand-render-layout";
import { BrandRenderTheme } from "./brand-render-theme";
import { visibleRenderPreviewPages } from "../../../../components/render-preview/render-preview";
import { resolveBrandCapabilities } from "../../../../../models/modules/render-brand-capabilities";
import { LotteryClientService } from "../../../../../services/modules/lottery-client.service";
var BrandRenderEditor = /** @class */ (function (_super) {
    __extends(BrandRenderEditor, _super);
    function BrandRenderEditor(notificationService, i18N, layout, theme, lotteryClientService) {
        var _this = _super.call(this, notificationService, i18N) || this;
        _this.layout = layout;
        _this.theme = theme;
        _this.lotteryClientService = lotteryClientService;
        _this.selectedPage = "lobby";
        _this.selectedSection = null;
        // Inline text-edit mode toggle: threads through to the shared preview (loads the iframe with the
        // key-tagging flag) so text can be clicked and edited in place.
        _this.editText = false;
        // Page tabs shown in the centre pane header (replaces the preview component's own picker). Rebuilt
        // per brand so a page the brand cannot fill (All Bundles with no bundles) is not offered.
        _this.previewPages = visibleRenderPreviewPages(null);
        // The edited brand's data capabilities, resolved once per activation and shared with the preview.
        _this.capabilities = null;
        // True while a right-panel click is driving the left selection, so the round-trip back through
        // onLayoutSelect doesn't force the colour group open again (it would block manual collapse).
        _this.syncingFromTheme = false;
        _this.layout.embeddedPreview = false;
        _this.theme.embeddedPreview = false;
        _this.layout.onSelect = function (section) { return _this.onLayoutSelect(section); };
        _this.theme.onSelectVariant = function (variantId) { return _this.onThemeSelectVariant(variantId); };
        // The Style panel reads placement LIVE from the layout panel and refreshes its colour groups
        // when a section is added/removed there (otherwise the new group only shows after a reload).
        _this.theme.layoutSectionsProvider = function () { return _this.layout.layout ? _this.layout.layout.sections : null; };
        _this.layout.onLayoutChanged = function () { return _this.theme.refreshColorSections(); };
        // Sections that carry one image per item (instant games) edit them in their own modal, but the
        // images are theme tokens, so the Structure pane reads and saves them through the Style pane.
        _this.layout.itemImageHost = _this.theme;
        return _this;
    }
    BrandRenderEditor.prototype.attached = function () {
        // The two embedded editors share this one centre preview for highlight + reload.
        this.layout.preview = this.preview;
        this.theme.preview = this.preview;
    };
    BrandRenderEditor.prototype.onActivated = function (model) {
        this.selectedSection = null;
        this.selectedPage = "lobby";
        this.capabilities = resolveBrandCapabilities(model);
        this.previewPages = visibleRenderPreviewPages(this.capabilities);
        this.resolveBundlesCapability(model ? model.brandId : null);
    };
    // The brand's bundles come from the lobby feed, not the brand model, so this lands after activation:
    // it refines the page tabs and the Structure pane's section gating once the answer is known.
    BrandRenderEditor.prototype.resolveBundlesCapability = function (brandId) {
        var _this = this;
        if (!brandId)
            return;
        this.lotteryClientService.getBundlesByBrand(brandId).then(function (bundles) {
            _this.capabilities = Object.assign({}, _this.capabilities, { bundles: (bundles || []).length > 0 });
            _this.previewPages = visibleRenderPreviewPages(_this.capabilities);
            _this.layout.applyCapabilities(_this.capabilities);
            if (_this.selectedPage === "bundles" && _this.capabilities.bundles === false)
                _this.onPreviewPageChanged("lobby");
        }).catch(function () { });
    };
    BrandRenderEditor.prototype.onPreviewPageChanged = function (page) {
        this.selectedPage = page;
        this.layout.onPreviewPageChanged(page);
        this.theme.onPreviewPageChanged(page);
        this.selectedSection = null;
    };
    BrandRenderEditor.prototype.onLayoutSelect = function (section) {
        this.selectedSection = section;
        // Open the matching colour group in the right (Style) panel for the selected section -
        // but not when this selection originated from a right-panel click (let its toggle stand).
        if (this.theme && section && !this.syncingFromTheme)
            this.theme.openColorSection(section);
    };
    BrandRenderEditor.prototype.onThemeSelectVariant = function (variantId) {
        this.syncingFromTheme = true;
        this.layout.selectByVariant(variantId);
        this.syncingFromTheme = false;
    };
    Object.defineProperty(BrandRenderEditor.prototype, "selectedSectionLabel", {
        get: function () {
            return this.selectedSection ? this.layout.variantLabel(this.selectedSection) : null;
        },
        enumerable: false,
        configurable: true
    });
    BrandRenderEditor.prototype.onTextEdit = function (key, value) {
        if (this.theme)
            this.theme.applyInlineText(key, value);
    };
    BrandRenderEditor = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [NotificationClientService,
            I18N,
            BrandRenderLayout,
            BrandRenderTheme,
            LotteryClientService])
    ], BrandRenderEditor);
    return BrandRenderEditor;
}(ChildComponent));
export { BrandRenderEditor };
